import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { dcrReviewStyles as sx } from './DcrReviewFooter/DcrReviewFooter.styles';

type Props = {
	label: string;
	summary?: string;
};

export const ReviewGroupHeader = ({ label, summary }: Props) => (
	<Box>
		<Typography component='span' sx={sx.changeLabel}>
			{label}
		</Typography>
		{summary && (
			<Typography component='span' sx={sx.groupSummary}>
				{' '}
				· {summary}
			</Typography>
		)}
	</Box>
);
